import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { InlineGroupComponent } from '@src/shared/structural/inline-group/inline-group.component';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { ModalLayoutComponent } from '../base-modal/modal-layout/modal-layout.component';

type ModalStatus = {
  style: 'warning' | 'error' | 'success' | 'none';
  title: string;
  message: string[];
  buttonLabel?: string | 'Stäng';
};

@Component({
  selector: 'woo-status-modal',
  imports: [ModalLayoutComponent, InlineGroupComponent, CommonModule],
  templateUrl: './status-modal.component.html',
  styleUrl: './status-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusModalComponent extends BaseModalComponent<ModalStatus> {
  status = this.modaldata;
}
